import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGridSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            热门版块
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            八大主题版块，涵盖技术、生活、娱乐、游戏等多元领域，总有一个你感兴趣的
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${cat.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mb-4 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>{cat.postCount.toLocaleString()} 帖子</span>
                <span className="text-accent-500">今日 {cat.todayCount}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}